import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ACTIVE_ELEVE_URL = `${backendUrl}/api/eleves/non_archived/`;
const NON_ACTIVE_ELEVE_URL = `${backendUrl}/api/eleves/archived/`;
const ELEVE_URL = `${backendUrl}/api/eleve/`;

class EleveService {
	async getAllEleves(salledeclasseId = null) {
		try {
			// Construire les paramètres de requête
			const params = new URLSearchParams();
			if (salledeclasseId !== null) {
				params.append('salledeclasseId', salledeclasseId);
			}

			// Envoyer la requête au backend avec les paramètres
			const response = await axios.get(ACTIVE_ELEVE_URL, { params });

			// Retourner les élèves filtrés directement depuis le backend
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	async getAllNonActiveEleves() {
		try {
			const response = await axios.get(NON_ACTIVE_ELEVE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getEleve(id) {
		const eleveId = Number.parseInt(id, 10);
		return axios.get(`${ELEVE_URL}${eleveId}/`);
	}

	createEleve(data) {
		return axios.post(ELEVE_URL, data).catch((error) => {
			console.error("Erreur lors de la création de l'élève", error);
			throw error;
		});
	}

	updateEleve(id, data) {
		return axios.patch(`${ELEVE_URL}${id}/`, data);
	}

	deleteEleve(id) {
		return axios.delete(`${ELEVE_URL}${id}/`);
	}

	getEleveOptions() {
		return this.getAllEleves().then((eleves) => {
			return eleves.map((eleve) => ({
				value: eleve.id,
				label: (eleve.nom + ' ' + eleve.prenom).toUpperCase()
			}));
		});
	}
}

export default new EleveService();
